// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_cr-0";
export var fileCarousel = "_cr-2";
export var removeFileButton = "_cr-1";